/* import __COLOCATED_TEMPLATE__ from './transaction-limits.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import { htmlSafe } from '@ember/template';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
function toPercent(numerator, denominator) {
  return Math.round(numerator / denominator * 100);
}
function toCssWidthPercent(percent) {
  return `width: ${percent.toString(10)}%`;
}
function assertCustomerLimitsValid(limits) {
  if (limits && limits.odfiWithdrawalAmountPerTransactionMax && limits.odfiWithdrawalAmountLimit && limits.odfiWithdrawalAmountLimit && limits.odfiDepositAmountPerTransactionMax && limits.odfiDepositAmountSum && limits.odfiDepositAmountLimit) {
    return limits;
  }
  throw new Error('CustomerLimits are not valid');
}
let TransactionLimitsComponent = (_dec = readOnly('sfsCustomerApi.remainingWeeklyWithdrawals'), _dec2 = readOnly('sfsCustomerApi.remainingWeeklyDeposits'), _class = class TransactionLimitsComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "sfsCustomerApi", _descriptor, this);
    _initializerDefineProperty(this, "limits", _descriptor2, this);
    _initializerDefineProperty(this, "remainingWeeklyWithdrawals", _descriptor3, this);
    _initializerDefineProperty(this, "remainingWeeklyDeposits", _descriptor4, this);
    this.limits = assertCustomerLimitsValid(args.limits);
  }
  get withdrawalPercentCss() {
    return htmlSafe(toCssWidthPercent(toPercent(this.limits.odfiWithdrawalAmountSum.amount, this.limits.odfiWithdrawalAmountLimit.amount)));
  }
  get depositPercentCss() {
    return htmlSafe(toCssWidthPercent(toPercent(this.limits.odfiDepositAmountSum.amount, this.limits.odfiDepositAmountLimit.amount)));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "sfsCustomerApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "limits", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "remainingWeeklyWithdrawals", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "remainingWeeklyDeposits", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TransactionLimitsComponent as default };